import { useEffect } from "react";
import { PageHeader } from "../components/lendx/PageHeader";
import { Reveal, SectionHeading } from "../components/lendx/Reveal";
import { CTABanner } from "../components/lendx/CTABanner";
import { ABOUT_PILLARS } from "../lib/data";
import { applySEO } from "../lib/scroll";

const HANDSHAKE =
  "https://images.pexels.com/photos/8112186/pexels-photo-8112186.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function AboutPage() {
  useEffect(() => {
    applySEO(
      "About LendX | Financial Advisory & Loan Facilitation India",
      "LendX simplifies access to financial solutions through professional advisory, structured financing approaches, and personalized client support."
    );
  }, []);

  return (
    <main data-testid="about-page">
      <PageHeader
        overline="About Us"
        title="Built Around Better Financial Decisions"
        sub="LendX focuses on simplifying access to financial solutions through professional advisory, structured financing approaches, and personalized client support."
        testId="about"
      />

      <section className="bg-white py-24 md:py-32">
        <div className="mx-auto grid max-w-7xl items-start gap-14 px-5 md:px-8 lg:grid-cols-2 lg:gap-24">
          <div>
            <SectionHeading
              overline="Who We Are"
              title="Clarity and Confidence in Every Funding Decision"
            />
            <Reveal delay={0.15}>
              <p className="mt-6 text-base leading-relaxed text-gray-600 md:text-lg">
                Our objective is to help clients understand their financing options and navigate the funding process with greater clarity and confidence. We work as advisors and facilitators — assessing requirements, structuring approaches, and coordinating with suitable financial institutions on your behalf.
              </p>
            </Reveal>
            <div className="mt-12 space-y-8">
              {ABOUT_PILLARS.map((p, i) => {
                const Icon = p.icon;
                return (
                  <Reveal key={p.title} delay={0.1 + i * 0.08}>
                    <div className="flex gap-6 border-l-2 border-gold/40 pl-6" data-testid={`about-page-pillar-${i + 1}`}>
                      <div>
                        <span className="flex h-11 w-11 items-center justify-center rounded-lg border border-gold-line bg-gold-tint text-gold-deep">
                          <Icon size={19} strokeWidth={1.6} />
                        </span>
                        <h3 className="mt-4 font-mono text-xs uppercase tracking-[0.25em] text-gold-deep">{p.title}</h3>
                        <p className="mt-2 max-w-md text-sm leading-relaxed text-gray-600 md:text-base">{p.text}</p>
                      </div>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>

          <Reveal delay={0.15} className="relative lg:sticky lg:top-28">
            <div className="absolute -right-4 -top-4 h-full w-full rounded-2xl border border-gold/40" />
            <div className="relative overflow-hidden rounded-2xl shadow-[0_16px_48px_rgba(16,20,24,0.12)]">
              <img src={HANDSHAKE} alt="LendX professional advisory partnership handshake" loading="lazy" className="h-[480px] w-full object-cover md:h-[560px]" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6">
                <p className="font-heading text-2xl font-semibold text-white">Your Finance. Simplified.</p>
                <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.25em] text-gold">LendX · India</p>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <CTABanner />
    </main>
  );
}
